import { IAuthUser } from '../_interfaces/ServerResponses';
import { ApiService } from '../_services/ApiService';

export class SignupService extends ApiService {
    protected basePath = 'signup';
    protected subPaths = {};

    public signup(data: Partial<IAuthUser>): Promise<{ user: IAuthUser; token: string }> {
        return this.postRequest(data).then(response => {
            return response;
        });
    }
}



// WEBPACK FOOTER //
// ./src/Services/SignupService.ts